"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCURuleFinallyOnWebsocket = exports.SCURuleFinallyOnAlertingConnection = exports.SCURuleFinallyOnTimeout = exports.SCURuleFinallyOnCron = exports.SCURuleFinallyOnInput = exports.SCURuleFinallyOnEvent = exports.SCUResetRuleType = exports.SCURuleFinally = void 0;
var cerealParse_1 = require("../cerealParse");
var scuRuleOn_1 = require("./scuRuleOn");
var scuConfig_1 = require("./scuConfig");
var SCURuleFinally = /** @class */ (function () {
    function SCURuleFinally(reset) {
        this.reset = reset;
    }
    SCURuleFinally.parse = function (o) {
        try {
            var trigger = cerealParse_1.ParseUtils.getEnum(o, 'reset', SCUResetRuleType);
            switch (trigger) {
                case SCUResetRuleType.onEvent:
                    return SCURuleFinallyOnEvent.parse(o);
                case SCUResetRuleType.onInput:
                    return SCURuleFinallyOnInput.parse(o);
                case SCUResetRuleType.onCron:
                    return SCURuleFinallyOnCron.parse(o);
                case SCUResetRuleType.onTimeout:
                    return SCURuleFinallyOnTimeout.parse(o);
                case SCUResetRuleType.onAlertingConnection:
                    return SCURuleFinallyOnAlertingConnection.parse(o);
                case SCUResetRuleType.onWebsocket:
                    return SCURuleFinallyOnWebsocket.parse(o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinally Model: Unhandled trigger '".concat(SCUResetRuleType[trigger], "'"));
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinally Model: ".concat(e.message));
        }
    };
    return SCURuleFinally;
}());
exports.SCURuleFinally = SCURuleFinally;
var SCUResetRuleType;
(function (SCUResetRuleType) {
    SCUResetRuleType[SCUResetRuleType["onEvent"] = 0] = "onEvent";
    SCUResetRuleType[SCUResetRuleType["onInput"] = 1] = "onInput";
    SCUResetRuleType[SCUResetRuleType["onCron"] = 2] = "onCron";
    SCUResetRuleType[SCUResetRuleType["onTimeout"] = 3] = "onTimeout";
    SCUResetRuleType[SCUResetRuleType["onAlertingConnection"] = 4] = "onAlertingConnection";
    SCUResetRuleType[SCUResetRuleType["onWebsocket"] = 5] = "onWebsocket";
})(SCUResetRuleType || (exports.SCUResetRuleType = SCUResetRuleType = {}));
var SCURuleFinallyOnEvent = /** @class */ (function (_super) {
    __extends(SCURuleFinallyOnEvent, _super);
    function SCURuleFinallyOnEvent(reset, event) {
        var _this = _super.call(this, reset) || this;
        _this.reset = reset;
        _this.event = event;
        return _this;
    }
    SCURuleFinallyOnEvent.prototype.toJson = function () {
        return {
            reset: SCUResetRuleType[this.reset],
            event: scuRuleOn_1.SCURuleEventType[this.event],
        };
    };
    SCURuleFinallyOnEvent.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleFinallyOnEvent(cerealParse_1.ParseUtils.getEnum(o, 'reset', SCUResetRuleType), cerealParse_1.ParseUtils.getEnum(o, 'event', scuRuleOn_1.SCURuleEventType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinallyOnEvent Model: ".concat(e.message));
        }
    };
    return SCURuleFinallyOnEvent;
}(SCURuleFinally));
exports.SCURuleFinallyOnEvent = SCURuleFinallyOnEvent;
var SCURuleFinallyOnInput = /** @class */ (function (_super) {
    __extends(SCURuleFinallyOnInput, _super);
    function SCURuleFinallyOnInput(reset, device, pin, condition) {
        var _this = _super.call(this, reset) || this;
        _this.reset = reset;
        _this.device = device;
        _this.pin = pin;
        _this.condition = condition;
        return _this;
    }
    SCURuleFinallyOnInput.prototype.toJson = function () {
        return {
            reset: SCUResetRuleType[this.reset],
            device: this.device,
            pin: this.pin,
            condition: this.condition
        };
    };
    SCURuleFinallyOnInput.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleFinallyOnInput(cerealParse_1.ParseUtils.getEnum(o, 'reset', SCUResetRuleType), cerealParse_1.ParseUtils.getString(o, 'device'), cerealParse_1.ParseUtils.getNumber(o, 'pin'), cerealParse_1.ParseUtils.getEnum(o, 'condition', scuConfig_1.SCUIODeviceInputCondition)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinallyOnInput Model: ".concat(e.message));
        }
    };
    return SCURuleFinallyOnInput;
}(SCURuleFinally));
exports.SCURuleFinallyOnInput = SCURuleFinallyOnInput;
var SCURuleFinallyOnCron = /** @class */ (function (_super) {
    __extends(SCURuleFinallyOnCron, _super);
    function SCURuleFinallyOnCron(reset, cron) {
        var _this = _super.call(this, reset) || this;
        _this.reset = reset;
        _this.cron = cron;
        return _this;
    }
    SCURuleFinallyOnCron.prototype.toJson = function () {
        return {
            reset: SCUResetRuleType[this.reset],
            cron: this.cron,
        };
    };
    SCURuleFinallyOnCron.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleFinallyOnCron(cerealParse_1.ParseUtils.getEnum(o, 'reset', SCUResetRuleType), cerealParse_1.ParseUtils.getString(o, 'cron')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinallyOnCron Model: ".concat(e.message));
        }
    };
    return SCURuleFinallyOnCron;
}(SCURuleFinally));
exports.SCURuleFinallyOnCron = SCURuleFinallyOnCron;
var SCURuleFinallyOnTimeout = /** @class */ (function (_super) {
    __extends(SCURuleFinallyOnTimeout, _super);
    function SCURuleFinallyOnTimeout(reset, timeout) {
        var _this = _super.call(this, reset) || this;
        _this.reset = reset;
        _this.timeout = timeout;
        return _this;
    }
    SCURuleFinallyOnTimeout.prototype.toJson = function () {
        return {
            reset: SCUResetRuleType[this.reset],
            timeout: this.timeout,
        };
    };
    SCURuleFinallyOnTimeout.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleFinallyOnTimeout(cerealParse_1.ParseUtils.getEnum(o, 'reset', SCUResetRuleType), cerealParse_1.ParseUtils.getNumber(o, 'timeout')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinallyOnTimeout Model: ".concat(e.message));
        }
    };
    return SCURuleFinallyOnTimeout;
}(SCURuleFinally));
exports.SCURuleFinallyOnTimeout = SCURuleFinallyOnTimeout;
var SCURuleFinallyOnAlertingConnection = /** @class */ (function (_super) {
    __extends(SCURuleFinallyOnAlertingConnection, _super);
    function SCURuleFinallyOnAlertingConnection(reset, connected) {
        var _this = _super.call(this, reset) || this;
        _this.reset = reset;
        _this.connected = connected;
        return _this;
    }
    SCURuleFinallyOnAlertingConnection.prototype.toJson = function () {
        return {
            reset: SCUResetRuleType[this.reset],
            connected: this.connected,
        };
    };
    SCURuleFinallyOnAlertingConnection.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleFinallyOnAlertingConnection(cerealParse_1.ParseUtils.getEnum(o, 'reset', SCUResetRuleType), cerealParse_1.ParseUtils.getBoolean(o, 'connected')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinallyOnAlertingConnection Model: ".concat(e.message));
        }
    };
    return SCURuleFinallyOnAlertingConnection;
}(SCURuleFinally));
exports.SCURuleFinallyOnAlertingConnection = SCURuleFinallyOnAlertingConnection;
var SCURuleFinallyOnWebsocket = /** @class */ (function (_super) {
    __extends(SCURuleFinallyOnWebsocket, _super);
    function SCURuleFinallyOnWebsocket(id, message) {
        var _this = _super.call(this, SCUResetRuleType.onWebsocket) || this;
        _this.id = id;
        _this.message = message;
        return _this;
    }
    SCURuleFinallyOnWebsocket.prototype.toJson = function () {
        return {
            reset: SCUResetRuleType[this.reset],
            id: this.id,
            message: this.message,
        };
    };
    SCURuleFinallyOnWebsocket.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleFinallyOnWebsocket(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleFinallyOnWebsocket: ".concat(e.message));
        }
    };
    return SCURuleFinallyOnWebsocket;
}(SCURuleFinally));
exports.SCURuleFinallyOnWebsocket = SCURuleFinallyOnWebsocket;
//# sourceMappingURL=scuRuleFinally.js.map